import React, { Suspense } from "react";
import PropTypes from "prop-types";
//import { Row, Col } from "reactstrap";
import LazySection from "../common/LazySection";
import LoadingSpinner from "../common/LoadingSpinner";

const AlbumDisplay = ({
  albumCover,
  logo,
  logoMobile,
  title,
  announcement,
  onImageError,
  style,
  className,
  children,
}) => (
  <div className="mainrow">
    {albumCover && (
      <div className={`albumpromo ${className || ""}`}>
        <img
          loading="eager"
          className="albumpromo"
          src={albumCover}
          alt={title ? `${title} Album Cover` : "Album Cover"}
          onError={onImageError}
          style={style}
        />
      </div>
    )}
    {logoMobile && logo && (
      <div className="albumlogo">
        {logo && (
          <img
            loading="eager"
            className="albumlogo"
            src={logo}
            alt="Band Logo"
            onError={onImageError}
          />
        )}
        {logoMobile && (
          <img
            loading="eager"
            className="albumlogoMobile"
            src={logoMobile}
            alt="Band Logo Mobile"
            style={{ display: "none" }}
            onError={onImageError}
          />
        )}
        {(title || announcement) && (
          <span style={{ marginTop: "10px" }}>
            {title && <p className="albumlogo">{title}</p>}
            {announcement && <p className="comingsoon">{announcement}</p>}
          </span>
        )}
      </div>
    )}
    {children && (
      <LazySection>
        <Suspense
          fallback={<LoadingSpinner message="Loading album content..." />}
        >
          <div className="albumcontentsample">{children}</div>
        </Suspense>
      </LazySection>
    )}
  </div>
);

AlbumDisplay.propTypes = {
  albumCover: PropTypes.string,
  logo: PropTypes.string,
  logoMobile: PropTypes.string,
  title: PropTypes.string,
  announcement: PropTypes.string,
  onImageError: PropTypes.func,
};

export default AlbumDisplay;
